import { Header } from '@ltvco/refresh-lib/v2';

type HeaderParentProps = {
  handleSearchSuccess: any;
};

export const HeaderParent = ({ handleSearchSuccess }: HeaderParentProps) => {
  return <Header onSearchSuccess={handleSearchSuccess} />;
};
